import React from 'react';
import { PDFExport } from '@progress/kendo-react-pdf';
import MemberTableBody from './MemberTableBody';
import TableRow from "./TableRow"

const ManageMemberTable = React.forwardRef(({ data }, ref) => {
    return (
        <>
            <div className="flex flex-col">
                <div className="overflow-x-auto ">
                    <div className="py-2 inline-block min-w-full">
                        <div className="overflow-hidden">

                            <PDFExport paperSize="A4" scale={0.6} avoidLinks={true} landscape={true} ref={ref}>
                                <table className="min-w-full border text-center" id='table-to-xls'>
                                    <thead className="tableborder font-semibold">
                                        <tr className="tableborder">
                                            <TableRow
                                                tableTitle="S.no"
                                            />
                                            <TableRow
                                                tableTitle="Plan"
                                            />
                                            <TableRow
                                                tableTitle="Max Branch"
                                            />
                                            <TableRow
                                                tableTitle="Max Member"
                                            />
                                            <TableRow
                                                tableTitle="Amount"
                                            />
                                            <TableRow
                                                tableTitle="Type"
                                            />
                                            <TableRow
                                                tableTitle="Reg.Date"
                                            />
                                            <TableRow
                                                tableTitle="Start Date"
                                            />
                                            <TableRow
                                                tableTitle="Expire Date"
                                            />
                                            <TableRow
                                                tableTitle="Remarks"
                                            />
                                            <TableRow
                                                tableTitle="Status"
                                            />
                                        </tr>
                                    </thead>
                                    <tbody className='hover:bg-gray-200'>
                                        {data.map((item, index) => <MemberTableBody key={index} item={item} />)}
                                    </tbody>
                                </table>
                            </PDFExport>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
});

export default ManageMemberTable
